import httpClient from '../utils/httpClient';

export const getProductRange = async (params) => {
  
    const response = await httpClient.post(`/carousel/categories`, params);
    return response.data;
};
